import { v4 as uuid } from 'uuid';
import BlockType from './BlockType';

interface BlockData {
  type: BlockType,
  id: string,
  data: any
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockData {
  export function make(type: BlockType, data: any): BlockData {
    return {
      id: uuid(),
      type,
      data,
    };
  }
}

export default BlockData;
